import { CONSTANTS } from '../../constants'; // Function in future will return some custom user formatting if exists,
// if not, will return default format from Constants

export var getDateFormat = function getDateFormat() {
  return CONSTANTS.FORMAT.DATE;
};
export var getDateTimeFormat = function getDateTimeFormat() {
  return CONSTANTS.FORMAT.DATE_TIME;
};